import React, { createContext, useContext } from "react";

const NamePrefixContext = createContext<string>("");

export const useNamePrefix = () => useContext(NamePrefixContext);

export const useInputFullName = (name?: string) => {
  const prefix = useNamePrefix();
  if (!name) return prefix;
  if (!prefix) return name;
  return `${prefix}.${name}`;
};

export const NamePrefixProvider: React.FC<{
  prefix?: string;
  children: React.ReactNode;
}> = ({ prefix = "", children }) => {
  const parentPrefix = useNamePrefix();
  const fullPrefix = parentPrefix ? `${parentPrefix}.${prefix}` : prefix;

  return (
    <NamePrefixContext.Provider value={fullPrefix}>
      {children}
    </NamePrefixContext.Provider>
  );
};
